//checking assessmentype
export const isCheckingAssessmentType = (type) => {
 return  type === "ELI" ? true : false;
};
